"use client"

import { useState } from "react"
import { SketchPicker } from "react-color"
import "./TagForm.css"
import { BiArrowToTop } from "react-icons/bi"
import { BsArrowDown } from "react-icons/bs"
import { CgArrowDown } from "react-icons/cg"

const colors = [
  { "nome": "Vermelho", "hex": "#FF0000", "texto": "#FFFFFF" },  // Branco para contraste
  { "nome": "Azul", "hex": "#0000FF", "texto": "#FFFFFF" },      // Branco para contraste
  { "nome": "Verde", "hex": "#00FF00", "texto": "#000000" },     // Preto para contraste
  { "nome": "Amarelo", "hex": "#FFFF00", "texto": "#000000" },   // Preto para contraste
  { "nome": "Roxo", "hex": "#800080", "texto": "#FFFFFF" },      // Branco para contraste
  { "nome": "Laranja", "hex": "#FFA500", "texto": "#000000" },   // Preto para contraste
  { "nome": "Rosa", "hex": "#FFC1CC", "texto": "#000000" },      // Preto para contraste
  { "nome": "Preto", "hex": "#000000", "texto": "#FFFFFF" },     // Branco para contraste
  { "nome": "Branco", "hex": "#FFFFFF", "texto": "#000000" },    // Preto para contraste
  { "nome": "Cinza", "hex": "#808080", "texto": "#FFFFFF" },     // Branco para contraste
  { "nome": "Turquesa", "hex": "#40E0D0", "texto": "#000000" },  // Preto para contraste
  { "nome": "Violeta", "hex": "#EE82EE", "texto": "#000000" },   // Preto para contraste
  { "nome": "Marrom", "hex": "#A52A2A", "texto": "#FFFFFF" },    // Branco para contraste
  { "nome": "Ciano", "hex": "#00FFFF", "texto": "#000000" },     // Preto para contraste
  { "nome": "Magenta", "hex": "#FF00FF", "texto": "#FFFFFF" }    // Branco para contraste
]

const TagForm = ({ initialValues = {}, onSubmit }) => {
  const [name, setName] = useState(initialValues.name || "")
  const [color, setColor] = useState(colors.filter(c => c.hex == initialValues.color)[0] ||{ nome: "Escolha a cor", hex: "#333333" })
  const [paymentAmount, setPaymentAmount] = useState(
    initialValues.paymentAmount ? initialValues.paymentAmount.toString() : "",
  )
  const [markHora, setMarkHora] = useState(initialValues.markHora || true)
  const [defaultStartTime, setDefaultStartTime] = useState(initialValues.defaultStartTime || "")
  const [defaultEndTime, setDefaultEndTime] = useState(initialValues.defaultEndTime || "")


  const [showColorPicker, setShowColorPicker] = useState(false)
  const [errors, setErrors] = useState({})

  const [showColors, setShowColors] = useState(false)
  const [selectedColor, setSelectedColor] = useState("")

  


  const validate = () => {
    const newErrors = {}

    if (!name.trim()) {
      newErrors.name = "O nome é obrigatório"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleTagChange = (e) => {
    const newTagId = e.target.value
    setColor(newTagId)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validate()) {
      onSubmit({
        name: name.trim(),
        color: color.hex,
        paymentAmount: Number.parseFloat(paymentAmount) || 0,
        defaultStartTime: defaultStartTime ? defaultStartTime : "00:00",
        defaultEndTime: defaultEndTime ? defaultEndTime : "00:00",
        time: markHora,
      })
    }
  }

  return (
    <>
      <form className="tag-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="name">
            Nome
          </label>
          <input
            type="text"
            id="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="form-group">
          <label className="form-label">Cor</label>

          <div style={{ background: color.hex, color: color.texto }} className="color-button" onClick={() => setShowColors(!showColors)}>
            <div>
              {color.nome}
            </div>
            <CgArrowDown className={showColors && "active-listcolor"} stroke="450px" />
          </div>
          <div className={`${showColors ? "colorActive" : ""} color-list`}>
            {colors.map((c) => (
              <div className="color-opt" style={{ background: c.hex, color: c.texto }}
                key={c.hex}
                value={c.hex}
                onClick={() => {
                  setShowColors(false)
                  setColor({ nome: c.nome, hex: c.hex, texto: c.texto })
                }}>{c.nome}</div>))}
          </div>


          {/* <select
            className={`form-control ${errors.tagId ? "is-invalid" : ""}`}
            value={color}
            style={{ background: color, color: "#eee",  }}
            onChange={handleTagChange}
          >
            <option value="">Selecione uma cor</option>
            {colors.map((color) => (
              <option style={{ background: color.hex, color: "#eee", margin: "20px" }}
                key={color.hex}
                value={color.hex}
                onClick={() => setColor(color.hex)}>{color.nome}</option>))}
          </select> */}
          {/* <div className="color-picker-container">
            <div
              className="color-preview"
              style={{ backgroundColor: color }}
              onClick={() => setShowColorPicker(!showColorPicker)}
            ></div>
            <input
              type="text"
              className="form-control color-input"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
          {showColorPicker && (
            <div className="color-picker-popover">
              <div className="color-picker-cover" onClick={() => setShowColorPicker(false)} />
              <SketchPicker color={color} onChange={(color) => setColor(color.hex)} />
            </div>
          )} */}
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="paymentAmount">
            Valor do Plantão (R$)
          </label>
          <input
            type="number"
            id="paymentAmount"
            className={`form-control ${errors.paymentAmount ? "is-invalid" : ""}`}
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
            min="0"
            step="0.01"
          />
          {errors.paymentAmount && <div className="invalid-feedback">{errors.paymentAmount}</div>}
        </div>

        <div className="form-group">

        </div>

        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px", gap: "5px" }}>
          <input type="checkbox" onChange={(e) => setMarkHora(e.target.checked)} checked={markHora} id="markHora" />
          <label htmlFor="markHora">Marcar Hora</label>
        </div>

            {markHora ? <>
            
        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="defaultStartTime">
              Horário de Início
            </label>
            <input
              type="time"
              id="defaultStartTime"
              className={`form-control ${errors.defaultStartTime ? "is-invalid" : ""}`}
              value={defaultStartTime}
              onChange={(e) => setDefaultStartTime(e.target.value)}
            />
            {errors.defaultStartTime && <div className="invalid-feedback">{errors.defaultStartTime}</div>}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="defaultEndTime">
              Horário de Término
            </label>
            <input
              type="time"
              id="defaultEndTime"
              className={`form-control ${errors.defaultEndTime ? "is-invalid" : ""}`}
              value={defaultEndTime}
              onChange={(e) => setDefaultEndTime(e.target.value)}
            />
            {errors.defaultEndTime && <div className="invalid-feedback">{errors.defaultEndTime}</div>}
          </div>
        </div>
        </> : <></>}

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </form>

      {/* Seção de pré-visualização */}
      <div className="preview-section">
        <h3 className="preview-title">Pré-visualização</h3>

        <div className="preview-container">
          <div className="preview-card">
            <h4 className="preview-subtitle">No calendário</h4>
            <div className="calendar-preview">
              <div className="calendar-day">
                <span className="day-number">15</span>
                <div className="calendar-dot" style={{ backgroundColor: color }}></div>
              </div>
            </div>
          </div>

          <div className="preview-card">
            <h4 className="preview-subtitle">Na lista de plantões</h4>
            <div className="shift-preview">
              <div className="shift-item">
                <div className="shift-color" style={{ backgroundColor: color }}></div>
                <div className="shift-details">
                  <div className="shift-name">{name || "Nome da Etiqueta"}</div>
                  <div className="shift-time">
                    {defaultStartTime || "08:00"} - {defaultEndTime || "18:00"}
                  </div>
                </div>
                <div className="shift-info">
                  <div className="shift-status pending">Pendente</div>
                  <div className="shift-amount">R$ {(Number.parseFloat(paymentAmount) || 0).toFixed(2)}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="preview-card">
            <h4 className="preview-subtitle">No resumo mensal</h4>
            <div className="summary-preview">
              <div className="tag-summary-header">
                <div className="tag-color" style={{ backgroundColor: color }}></div>
                <div className="tag-name">{name || "Nome da Etiqueta"}</div>
              </div>
              <div className="tag-summary-details">
                <div className="tag-summary-item">
                  <div className="tag-summary-label">Valor</div>
                  <div className="tag-summary-value">R$ {(Number.parseFloat(paymentAmount) || 0).toFixed(2)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TagForm

